define('app/factories/location_city_select_zone',['app/setup','app/views/location_city_select_zone'],
  function(takhfifan,LocationCityZoneSelector) {
    $('.tkh-city-zones').each(function(){
      new takhfifan.LocationCityZoneSelector({
        el: $(this)
      });
    });
  });
